import { getDefaultExportFromCjs as e } from "./index361.js";
import { __require as r } from "./index774.js";
var o = r();
const m = /* @__PURE__ */ e(o);
export {
  m as default
};
